import { getAccessToken } from '@/lib/auth';
import type { DirectoryCell } from './cell-store';

export async function fetchMyCells(accessToken?: string | null): Promise<DirectoryCell[]> {
  const token = accessToken ?? (await getAccessToken());
  if (!token) throw new Error('Not authenticated');
  const base = import.meta.env.VITE_CELL_DIRECTORY_URL?.replace(/\/$/, '');
  if (!base) throw new Error('VITE_CELL_DIRECTORY_URL is required');
  const res = await fetch(`${base}/v1/me/cells`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Unable to load markets');
  const body = (await res.json()) as { data?: DirectoryCell[] };
  return body.data ?? [];
}
